import SearchableDropdown from '@EUForms/searchableDropdown'
import React from 'react'
import { Icon } from 'semantic-ui-react'
import DropDown from '../../commonComponents/formComponents/dropDown'
import InputField from '../formComponents/inputField'

const CountryOfRoutingItem = (props) => {
  const {
    item,
    itemNumber,
    valueKey,
    isFormDisabled,
    saveData,
    updateData,
    deleteData,
    dataSource,
    autoFocus,
    fieldType,
    copyDocument, 
    handleCopyEnabled=()=>{},
    ...rest
  } = props
  
  const searchFunction = (arr, pattern) => {
    let regex = new RegExp(pattern, 'i')
    let result = []
    for (let i = 0; i < arr.length; i++) {
      const obj = arr[i]
      let score = 0
      for (let key in obj) {
        if (typeof obj[key] === 'string') {
          if (obj[key].startsWith(pattern)) {
            score += 2
          } else if (obj[key].match(regex)) {
            score += 1
          }
        }
      }
      if (score > 0) {
        result.push({ obj, score })
      }
    }
    result.sort((a, b) => b.score - a.score)
    return result.map((item) => item.obj)
  }
  const isCurrentElemDisabled = (rest?.isParentDisabled||(rest?.isRFI&&item?.markDelete=='1')||null)
  const field = {
    input: (
      <InputField
        // autoFocus={autoFocus}
        id={`sealNumber`}
        type='text'
        disabled={isFormDisabled}
        value={item?.[valueKey]}
        className={'field-bg routingForm-input'}
        clearInput={false}
        onChange={(value) => {
          updateData && updateData(item?.id, { [valueKey]: value })
        }}
        onBlur={(value) => {
          saveData && saveData({ id: item?.id, isNewly:item?.isNewly, [valueKey]: value })
        }}
        isDisabled={isCurrentElemDisabled}
      />
    ),
    dropdown: (
      <DropDown
        autoFocus={autoFocus}
        id='countriesofroutingcodes'
        data={dataSource}
        disabled={isFormDisabled}
        className={'field-bg routingCountryDropdown'}
        value={item?.[valueKey]}
        text={rest?.countryCode === 'NL' && item?.[valueKey] !== 'ZZ' && item?.[valueKey]}
        onChange={(value) => {
          saveData && saveData({ id: item?.id || '', [valueKey]: value || ' ' })
          updateData && updateData(item?.id, { [valueKey]: value })
        }}
        search={(list, value) => {
          return searchFunction(list, value)
        }}
        isDisabled={isCurrentElemDisabled}
      />
    ),
    searchableDropdown: (
      <SearchableDropdown
        id='multiplesearchableDropDown'
        columnClassName='search__position'
        containerClass='multi_search___label'
        {...rest}
        selectedValue={item?.[valueKey]}
        onSelect={({ value }) => {
          saveData && saveData({ id: item?.id || '', [valueKey]: value || ' ' })
          updateData && updateData(item?.id, { [valueKey]: value })
        }}
        onBlur={({ value }) => updateData && updateData(item?.id, { [valueKey]: value })}
        isDisabled={isCurrentElemDisabled}
        upward={false}
      />
    ),
  }
  return (
    <div className='routingFormContainer'>
      <div className='routingForm'>
        {/* {contry && undg && copydocument()}  */}
        {copyDocument && copyDocument(item, handleCopyEnabled)}
        <div className='routingForm-items'>{itemNumber}</div>
        <div 
        id={`dropdown-${item?.id}`}
        className='dropdownItem'
        >
          {field[fieldType]}
        </div>
        <div className='routingForm-items'>
          {rest?.markedDeleted?rest?.markedDeleted({
            id:item?.id, 
            tableName:rest?.tableName, 
            markDelete:item?.markDelete=='1'
          }):<Icon
            id={`${item?.id}-deleteContainerInner`}
            className='trash'
            color='red'
            name='trash'
            disabled={isFormDisabled}
            onClick={() => {
              deleteData(item?.id)
            }}
          />}

        </div>
      </div>
      { rest?.draggable && <div className='insertRowIcon'>
      <Icon
          id={`${item?.id}-addContainer`}
          className='add'
          color='blue'
          name='plus'
          disabled={isFormDisabled}
          onClick={() => {
          rest.AddItem(item?.orderNumber)
          }}
        />
      </div>}
    </div>
  )
}

export default React.memo(CountryOfRoutingItem)
